import { getTranslations } from "./translation.service";
import getBusinessConfig from "./business.service";
import { loadGoogleMaps } from "./maps.service";

import { getUserInfo } from "./user.service";
import { loadFlow } from "./flow.service";
import { BehaviorSubject } from "rxjs";

let ready = 0;
const readyobsrv = new BehaviorSubject(ready);

const required_sources = [
	getTranslations,
	getBusinessConfig,
	loadGoogleMaps,
	loadFlow,
	getUserInfo,
];

const SourcesCount = required_sources.length;

const readyPlus = (data) => {
	if (data) {
		readyobsrv.next(++ready);
	}
};

const fetchEssentials = () => {
	for (let source of required_sources) {
		source().subscribe(readyPlus);
	}
	return readyobsrv;
};

export { SourcesCount, fetchEssentials };
